module.exports = __webpack_public_path__ + "@/assets/img/spam.228aceb6.svg";